import { call, put } from "redux-saga/effects";
import { apiRequest } from "../../../../Utils/axiosApi";
import { API_METHODS, ENDPOINTS } from "../../../endpoint";
import { Actions } from "../../../constants/actionTypes";
import { getStore } from "../../../../Utils/storeUtils";

// apiRequest resolves (not throws) on a 4xx/5xx; the API's message sits on the axios error
const errorDataOf = (result) =>
  result?.response?.data || result?.data?.response?.data || result?.data;

// The meta callbacks are called here, once; the watcher saga only calls this generator.
export function* apiNewDomain(action) {
  try {
    const result = yield call(apiRequest, {
      url: `${ENDPOINTS.SITE_DETAILS}/addSiteDomain`,
      method: API_METHODS.POST,
      data: action.data,
    });
    if (result.isApiSuccessful) {
      action.meta?.onSuccess?.(result.data);
      return result;
    } else {
      // e.g. 409 "domain already exists": the page shows the server's message
      action.meta?.onError?.(errorDataOf(result));
      return { isApiSuccessful: false, data: result.data };
    }
  } catch (err) {
    action.meta?.onError?.(errorDataOf(err));
    return { isApiSuccessful: false, data: err };
  }
}

// EBS (v2) sites: the custom domains with their ACM validation record, certificate and
// CloudFront target. Called once on the page, kept in local state there.
export function* apiEbsSiteDomains(action) {
  try {
    const result = yield call(apiRequest, {
      url: `${ENDPOINTS.SITE_DETAILS}/${action.data.siteId}/ebsDomains`,
      method: API_METHODS.GET,
    });
    if (result.isApiSuccessful) {
      action.meta?.onSuccess?.(result.data);
      return result;
    } else {
      action.meta?.onError?.(result);
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    action.meta?.onError?.(err);
    return { isApiSuccessful: false, data: err };
  }
}

export function* deleteStagingDomain(action) {
  try {
    const result = yield call(apiRequest, {
      url: `${ENDPOINTS.SITE_DETAILS}/delete/stagingDomain/${action.data.stagingDomainName}`,
      method: API_METHODS.DELETE,
    });

    if (result.isApiSuccessful) {
      action.meta.onSuccess(result.data);
      return result;
    } else {
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* fetchS3PresignedUrl(action) {
  try {
    const result = yield call(apiRequest, {
      method: "GET",
      url: `/AWS/S3PresignedURL?fileName=${action.fileName}`,
    });
    if (process.env.REACT_APP_TEMP_DOMAIN === "roconpaas.io") {
      // console.log("After API Proimse of All Sites", getStore().getState());
    } else {
      console.log("After API Proimse of All Sites", getStore().getState());
    }

    if (result.isApiSuccessful) {
      yield put({ type: Actions.SET_S3_SIGNED_URL, data: result.data });
      return result;
    } else {
      // Toast("Technical error", "Failed to fetch the Sites", "danger");
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    // Toast("Technical error", "Failed to fetch the Sites", "danger");
    return { isApiSuccessful: false, data: err };
  }
}

// The meta callbacks are called here, once; the watcher saga only calls this generator.
// lbArn is the v1 load balancer; EBS (v2) sites have none and send no query string.
export function* apiRemoveDomain(action) {
  try {
    const lbArn = action.data?.lbArn;
    const result = yield call(apiRequest, {
      method: "DELETE",
      url: `/siteDetails/delete/${action.data.siteId}/domain/${action.data.domainId}${
        lbArn !== undefined && lbArn !== null ? `?lbArn=${lbArn}` : ""
      }`,
    });

    if (result.isApiSuccessful) {
      action.meta?.onSuccess?.(result.data);
      return result;
    } else {
      action.meta?.onError?.(errorDataOf(result));
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    action.meta?.onError?.(errorDataOf(err));
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiSitesDomainSslStatus(action) {
  try {
    const result = yield call(apiRequest, {
      method: "POST",
      url: `/siteDetails/${action.data.siteId}/domain/${action.data.domainId}`,
    });
    if (result.isApiSuccessful) {
      action.meta.onSuccess();
      return result;
    } else {
      action.meta.Error();
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiMakeTempDomainLive(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/siteDetails/makeTemporaryDomainLive?siteId=${action.data.siteId}`,
      method: "POST",
    });
    if (result.isApiSuccessful) {
      return result;
    } else {
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiSslStatus(action) {
  try {
    const result = yield call(apiRequest, {
      method: "GET",
      url: `/AWS/getSslStatus?lbArn=${action.lbArn}`,
    });
    yield put({
      type: Actions.SET_DOMAIN_SSL_STATUS,
      data: result.data,
    });

    return result;
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiCheckDnsStatus(action) {
  try {
    const result = yield call(apiRequest, {
      method: API_METHODS.GET,
      url: `/siteDetails/checkDnsStatus`,
      params: { domain: action.data.domain, ip: action.data.ip },
    });
    if (result.isApiSuccessful) {
      action.meta?.onSuccess(result.data);
      return result;
    } else {
      action.meta?.onError(result.data);
      return { isApiSuccessful: false, data: result.data };
    }
  } catch (err) {
    action.meta?.onError(err);
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiRoconSslhandler(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/ssl/sslHandler`,
      method: "POST",
      data: action.data,
    });
    if (result.isApiSuccessful) {
      return result;
    } else {
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}
